<template>
  <div class="link-list">
    <h4 class="link-list__heading" v-if="headingUrl !== 'https://www.sciarc.edu/admissions/thank-you'">
      <a :href="headingUrl" @click="ga4dl">{{ heading }}</a>
    </h4>

    <ul class="link-list__items">
      <li 
        v-for="(item, index) in validItems" :key="index"
        :class="['link-list__item', {'hide-in-menu': item.hideInMenu}]"
      >
      <template v-if="item.label.toLowerCase() !== 'Campus Life'.toLowerCase()">
        <a :href="item.url" @click="ga4dl"> {{ item.label }} </a>
      </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LinkList',

  props: {
    heading: String,
    headingUrl: String,
    items: Array
  },

  computed: {
    validItems () {
      let urlLinks = ['https://www.sciarc.edu/academics/undergraduate/design-studio', 'https://www.sciarc.edu/academics/undergraduate/liberal-arts', 'https://www.sciarc.edu/academics/undergraduate/history-theory', 'https://www.sciarc.edu/academics/undergraduate/visual-studies', 'https://www.sciarc.edu/academics/undergraduate/applied-studies', 'https://www.sciarc.edu/academics/undergraduate/undergraduate-course-catalog', 'https://www.sciarc.edu/academics/graduate/m-arch-1-course-catalog', 'https://www.sciarc.edu/academics/graduate/m-arch-2-course-catalog']
      if (this.items) {
        return [...this.items].filter(item => {
          if(urlLinks.includes(item.url))
            return false
          else
            return item.label && item.url
        })
      } else {
        return []
      }
    }
  },

  methods: {
    ga4dl(event) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
         'event': 'menu_clicks',
         'button_name': event.target.textContent
      })
    }
  },

  mounted() {
    this.validItems.forEach(item => {
      console.log(`Item label: ${item.label}, hideInMenu: ${item.hideInMenu}`);
    });
  }
}
</script>
